import React, {Component} from 'react';
import {Input, Table, Segment, Label} from 'semantic-ui-react';
import Dropzone from 'react-dropzone'

class Admin extends Component {

  /***** Page Functions *****/
  constructor(props) {
    super(props);
    this.state = {
      userSettings: {"username": "rajsingh@lpc.nyc.gov", "userpassword": "Samsac1003#", "userprofile": "RAJSINGH"},
      lpcSettings: {
        contactname: "NYC LANDMARKS PRESERVATION COMMISSION",
        address: "1 CENTRE STREET 9TH FLOOR NORTH",
        city: "NEW YORK",
        state: "NY",
        zip: "10007",
        email: "rajsingh@lpc.nyc.gov"
      }
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {

  }

  render() {
    const userSettings = this.state.userSettings;
    const lpcSettings = this.state.lpcSettings;

    return (
      <form onSubmit={this.handleSubmit}>
        <div>
          <Segment raised>
            <Label as='a' color='blue' ribbon>
              User Information
            </Label>
            <Table celled>
              <Table.Body>
                <Table.Row>
                  <Table.Cell>User Name</Table.Cell>
                  <Table.Cell>
                    <Input placeholder='username@lpc.nyc.gov' type="password" defaultValue={userSettings.username}
                           onChange={this.handleInputChange}/>
                  </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>User Password</Table.Cell>
                  <Table.Cell>
                    <Input placeholder='password' type="password" defaultValue={userSettings.userpassword}
                           onChange={this.handleInputChange}/>
                  </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>User Profile</Table.Cell>
                  <Table.Cell>
                    <Input placeholder='userprofile' type="password" defaultValue={userSettings.userprofile}
                           onChange={this.handleInputChange}/>
                  </Table.Cell>
                </Table.Row>
              </Table.Body>
            </Table>
          </Segment>

          <Segment raised>
            <Label as='a' color='blue' ribbon>
              Agency Information
            </Label>
            <Table celled>
              <Table.Body>
                <Table.Row>
                  <Table.Cell>Contact Name</Table.Cell>
                  <Table.Cell>
                    <Input fluid placeholder='LANDMARKS PRESERVATION COMMISSION' defaultValue={lpcSettings.contactname}
                           onChange={this.handleInputChange}/>
                  </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Address</Table.Cell>
                  <Table.Cell>
                    <Input fluid placeholder='1 CENTRE STREET' defaultValue={lpcSettings.address}
                           onChange={this.handleInputChange}/>
                  </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>City</Table.Cell>
                  <Table.Cell>
                    <Input placeholder='userprofile' defaultValue={lpcSettings.city} onChange={this.handleInputChange}/>
                  </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>State</Table.Cell>
                  <Table.Cell>
                    <Input placeholder='NY' defaultValue={lpcSettings.state} onChange={this.handleInputChange}/>
                  </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Zip Code</Table.Cell>
                  <Table.Cell>
                    <Input placeholder='10007' defaultValue={lpcSettings.zip} onChange={this.handleInputChange}/>
                  </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Email Address</Table.Cell>
                  <Table.Cell>
                    <Input fluid placeholder='user@lpc.nyc.gov' defaultValue={lpcSettings.email}
                           onChange={this.handleInputChange}/>
                  </Table.Cell>
                </Table.Row>
              </Table.Body>
            </Table>
          </Segment>
          <Segment raised>
            <Label as='a' color='blue' ribbon>
              Upload New DOF Address File data
            </Label>
            <table>
              <tr>
                <td>
                  <Dropzone onDrop={(files) => this.onDrop(files)}>
                    <div>
                      Drop file received from DOF for address lookup. Please upload only one file.
                      <br />
                    </div>
                  </Dropzone>
                </td>
                <td>Last Update: 02 Jul 2018</td>
              </tr>
            </table>
          </Segment>

        </div>
      </form>)
  }

  onDrop(acceptedFiles, rejectedFiles) {
    this.uploadFile(acceptedFiles[0])
  }

  //upload file to server
  uploadFile(argFile) {
    const request = require('superagent');
    //const results = this.state.results
    const req = request.post(window.globalAppTrackURL + "UploadDOFFile")
    req.attach("file", argFile)
    req.end(function (err, res) {
      if (err) {
        console.log("error ocurred");
      }
    })
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    this.setState({
      [name]: value
    });
  }

  handleSubmit(event) {
    event.preventDefault();
  }

}
export default Admin




// WEBPACK FOOTER //
// ./src/components/Admin.js